import {
  SET_ID,
  SET_STAFFID,
  SET_STAFFNAME,
  SET_EMAIL,
  SET_DESIGNATION,
  SET_ROLE_PERMISSIONS, // ✅ new
} from './actions';

const initialState = {
  id: '',
  staffid: '',
  staffname: '',
  email: '',
  designation: '',
   roleName: '',           // ✅ new
  permissions: {},       // ✅ store permissions by role
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ID:
      return {
        ...state,
        id: action.payload,
      };
    case SET_STAFFID:
      return {
        ...state,
        staffid: action.payload,
      };
    case SET_STAFFNAME:
      return {
        ...state,
        staffname: action.payload,
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SET_DESIGNATION:
      return {
        ...state,
        designation: action.payload,
      };
  case SET_ROLE_PERMISSIONS:
      return {
        ...state,
        roleName: action.payload.roleName,
        permissions: action.payload.permissions,
      };
    default:
      return state;
  }
};

export default reducer;
